<template>
    <div class="wrapper">
        <h2 class="page_title">{{ $t("page.onebox.mainheader") }}</h2>
        <div class="container_block">
            <OrderedListRecurring :list="instruction" />

            <iframe
                class="player"
                src="https://www.youtube.com/embed/MYQbOWT-c0U"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowfullscreen
            ></iframe>

            <BaseCardInstruction>
                <div class="listText">
                    <p v-for="text in afterActivation" :key="text" class="my-3">
                        {{ $t(text) }}
                    </p>
                </div>
            </BaseCardInstruction>
        </div>
    </div>
</template>
<script>
import OrderedListRecurring from "@/components/Recurring/OrderedListRecurring.vue";
import BaseCardInstruction from "@/components/Instruction/BaseCardInstruction.vue";
import HeaderMain from "@/components/Recurring/HeaderMain.vue";
import ButtonConfirm from "@/components/Recurring/ButtonConfirm";
import TextNumBlock from "@/components/Recurring/TextNumBlock";

export default {
    components: {
        OrderedListRecurring,
        BaseCardInstruction,

        HeaderMain,
        ButtonConfirm,
        TextNumBlock,
    },
    data() {
        return {
            instruction: [
                "page.onebox.text1",
                "page.onebox.text2",
                "page.onebox.text3",
                "page.onebox.text4",
                "page.onebox.text5",
                "page.onebox.text6",
            ],
            afterActivation: [
                "page.onebox.text9",
                "page.onebox.text10",
                "page.onebox.text11",
            ],
        };
    },
};
</script>

<style lang="scss" scoped>
@use "@/styles/pages/instruction.scss";

.listText {
    margin-top: -16px;
    margin-bottom: -16px;
}

.player {
    width: 100%;
    border-radius: 11px;
    height: 500px;
    margin: 20px 0;
}

@media screen and (max-width: 645px) {
    .player {
        height: 300px;
    }
}
</style>
